import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	styled,
} from '@mui/material';

export const StyledAccordion = styled(Accordion)`
	border-bottom: 1px solid ${({theme}) => theme.palette.other.divider};
	box-shadow: none;

	&::before {
		display: none;
	}
`;

export const StyledAccordionSummary = styled(AccordionSummary)<{
	$isRefund?: boolean;
}>`
	padding-left: 0;
	padding-right: 0;
	padding-top: 0;
	padding-bottom: 0;

	${({$isRefund}) =>
		$isRefund &&
		`
		& .MuiAccordionSummary-expandIconWrapper {
			display: none;
		}

		& .MuiAccordionSummary-content {
			margin: 0;
		}
	`}
`;

export const StyledAccordionDetails = styled(AccordionDetails)<{
	$isRefund?: boolean;
}>`
	padding-left: ${({$isRefund}) => ($isRefund ? 0 : '48px')};
	padding-right: 0;
	padding-bottom: ${({theme}) => theme.spacing(2)};
	padding-top: 0;
`;
